import { render, staticRenderFns } from "./InicioConMapa.vue?vue&type=template&id=bb50f72c&scoped=true"
import script from "./InicioConMapa.vue?vue&type=script&lang=js"
export * from "./InicioConMapa.vue?vue&type=script&lang=js"
import style0 from "./InicioConMapa.vue?vue&type=style&index=0&id=bb50f72c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb50f72c",
  null
  
)

export default component.exports